export default function validationBrief(brief, errors) {
  if (!brief.produitLocation) {
    errors.push('reseauTempo.brief.errors.produitLoc');
  }
}
